// Le choix de la langue de l'interface, partout le même (issue #137).
//
// Un menu déroulant natif plutôt qu'une rangée de boutons « FR / EN » : à
// cinq langues la rangée ne tenait plus, surtout au téléphone. Chaque langue
// est écrite dans sa propre langue (« Nederlands », pas « Néerlandais ») : on
// la cherche dans la langue qu'on lit. Jamais de drapeau : un drapeau désigne
// un pays, pas une langue, et la Belgique en parle trois.

import { Globe } from 'lucide-react'
import { NOM_NATIF } from '@ai-job-fit/engine/langues'
import { languesProposees, type Lang } from '../lib/lang'
import { useT } from '../lib/i18n'

export function SelecteurLangue({ value, onChange, className }: { value: Lang; onChange: (l: Lang) => void; className?: string }) {
  const t = useT()
  return (
    <label className={className ? `langsel ${className}` : 'langsel'}>
      <Globe size={15} aria-hidden="true" />
      <select aria-label={t('lang.toggle.label')} value={value} onChange={(e) => onChange(e.target.value as Lang)}>
        {languesProposees(value).map((l) => (
          <option key={l} value={l} lang={l}>
            {NOM_NATIF[l]}
          </option>
        ))}
      </select>
    </label>
  )
}
